import { resourceCatalog } from '../data/resources/catalog'
const origin = 'https://www.advantagehorsemanship.com'
export function resourceArticleSchema(id: string, title: string, description: string, category: string) {
  const url = `${origin}/resources/${id}`
  return [
    { '@type': 'Article', '@id': `${url}#article`, headline: title, description, author: { '@type': 'Person', name: 'Scott Purdum', url: `${origin}/about` }, publisher: { '@type': 'Organization', name: 'Advantage Horsemanship', url: origin }, mainEntityOfPage: url, articleSection: category, inLanguage: 'en-US' },
    { '@type': 'BreadcrumbList', itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Resources', item: `${origin}/resources` },
      { '@type': 'ListItem', position: 2, name: title, item: url },
    ] },
  ]
}
export const resourceLibrarySchema = {
  '@type': 'CollectionPage', name: 'Free Horsemanship Playbooks', url: `${origin}/resources`,
  mainEntity: { '@type': 'ItemList', itemListElement: [{ id: 'riders-foundation', title: 'The Rider’s Foundation' }, ...resourceCatalog].map((guide, i) => ({ '@type': 'ListItem', position: i + 1, name: guide.title, url: `${origin}/resources/${guide.id}` })) },
}
